import { useEffect, useLayoutEffect } from 'react';

/**
 * A hook that supports SSR by using the useEffect hook on
 * the server and the useLayoutEffect hook on the client when possible.
 */

export var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;